import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarTaskApi } from "../../http/carTasks/api";
import { InsertCarTask } from "../../http/carTasks/types";
import ModalDialog from "../ui/ModalDialog";
import CarTaskForm, { CarTaskFormBody } from "./CarTaskForm";

interface CreateCarTaskDialogProps {
  carId?: string;
  onClose: (success?: boolean) => void;
  isWithDefaultTask?: boolean;
}

const CreateCarTaskDialog: FC<CreateCarTaskDialogProps> = ({ carId, onClose, isWithDefaultTask }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const carsTaskApi = useCarTaskApi();

  const onSubmit = async (formData: CarTaskFormBody) => {
    const body: InsertCarTask = {
      taskName: formData.name,
      defaultTaskId: formData.defaultTask?.id,
    };

    const id = carId || formData.car?.id;

    if (id) {
      setIsSubmitting(true);
      try {
        await carsTaskApi.insertAdminCarTask(id, body);
        dispatch(showSuccessNotification(i18n.t));
        onClose(true);
      } catch (error) {
        dispatch(showErrorNotification(i18n, error));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <ModalDialog onClose={onClose} title={i18n.t.carTasks.new}>
      <CarTaskForm isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} isWithDefaultTask={isWithDefaultTask} />
    </ModalDialog>
  );
};

export default CreateCarTaskDialog;
